import React, { useState } from 'react';
import { FilterPicker, RadioButtonWithLabel } from 'seagull';
import { aggregateOptions } from "../../RevenueBreakdown/RevenueBreakdown.utils";
const RadioFilterPicker = _ref => {
  let {
    title,
    testId,
    defaultLabel,
    selectedValue,
    onApply: _onApply,
    setValue
  } = _ref;
  const [label, setLabel] = useState(defaultLabel);
  return /*#__PURE__*/React.createElement(FilterPicker, {
    "data-testid": testId,
    label: label,
    title: title || label,
    highlightTrigger: false,
    onApply: () => _onApply(selectedValue),
    onClose: () => {}
  }, aggregateOptions.map(_ref2 => {
    let {
      value,
      text
    } = _ref2;
    return /*#__PURE__*/React.createElement(RadioButtonWithLabel, {
      key: value,
      label: text,
      testId: "".concat(testId, "-option-").concat(value),
      checked: value === selectedValue,
      onChange: () => {
        setValue(value);
        setLabel(text);
      }
    });
  }));
};
export default RadioFilterPicker;